import moment from "moment/moment";
import { formatDate } from "@/utils/helpers/date-time/datetime-format";

export const getBudgetDetailsAccumulatedCostMonthlyDateOptions = (
  startDate?: string,
) => {
  const dateOptions = [];
  const now = moment();
  const currentDate = moment(startDate).startOf("month");

  while (currentDate.isSameOrBefore(now, "month")) {
    const isCurrentMonth = currentDate.isSame(now, "month");
    dateOptions.push({
      value: formatDate(currentDate, { type: "yearMonthDay" }),
      title: `${formatDate(currentDate, { format: "MMMM YYYY" })}${isCurrentMonth ? " (MTD)" : ""}`,
    });
    currentDate.add(1, "month");
  }

  return dateOptions;
};
